<template>
  <div class="returnAdd">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('returnDetail.collapseTitle.baseTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <base-form
            ref="baseForm"
            @changeCompany="changeCompany"
            @focusChange="focusChange"
            @setOutboundStorageNo="setOutboundStorageNo"
            @changeBlur="changeBlur"
            @clearGoodsTable="clearGoodsTable"
            @searchModalContractNo="searchModalContractNo"
            :type="$route.query.type"
          />
        </div>
      </el-collapse-item>
      <!-- <el-collapse-item name="2"> -->
      <el-tabs type="card" v-model="activeNameTab" class="common-tab">
        <el-tab-pane
          :label="
            $route.query.type == '0'
              ? $t('returnDetail.collapseTitle.changeGoodsTitle')
              : $t('returnDetail.collapseTitle.returnGoodsTitle')
          "
          name="first"
        >
          <goods-table
            ref="goodsTable"
            @calculate="calculate"
            @calculateQuantity="calculateQuantity"
            @throwData="throwData"
            @calculateFee="calculateFee"
            @calculateNonInvoiceQuantity="calculateNonInvoiceQuantity"
            @calculateInvoiceAmount="calculateInvoiceAmount"
            :type="$route.query.type"
            :baseFormReturnCompanyCode="baseFormReturnCompanyCode"
            @insertEvent="insertEvent"
            :baseData="baseData"
          />
        </el-tab-pane>
        <el-tab-pane name="voucherTab" :label="$t('addInvoice.invoiceLine.title2')">
          <voucher
            ref="voucher"
            :voucherList="voucherList"
            @reverseInfo="reverseInfo"
            @postInfo="postInfo"
            @doConfirmInfo="doConfirmInfo"
          ></voucher>
        </el-tab-pane>
      </el-tabs>
      <!-- </el-collapse-item> -->
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('returnDetail.collapseTitle.fileTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <upload
            ref="upload"
            defaultPath="scm/warehouseContract"
            :tableData="attachments"
            @upload="uploadList"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <el-button
        type="primary"
        v-hasPermi="['2021042915361219951']"
        @click="save('ZT06')"
        :loading="load"
        class="fixed-bottom-btn"
        v-if="status == 'ZT01' || status == 'ZT05' || status == 'ZT06'"
        >{{ this.$t('returnDetail.btnList.save') }}</el-button
      >
      <el-button
        class="saveBtn"
        type="primary"
        v-hasPermi="['2021042915361219951']"
        @click="saveActualInboundQuantity"
        v-if="status == 'ZT07' && isDirectDeliver == 1"
        >{{ $t('returnDetail.btnList.save') }}</el-button
      >
      <!-- 提交 -->
      <el-button
        type="primary"
        v-hasPermi="['2021042915364140077']"
        @click="save('ZT02')"
        :loading="load"
        v-if="status == 'ZT01' || status == 'ZT05' || status == 'ZT06'"
        class="fixed-bottom-btn"
        >{{ this.$t('returnDetail.btnList.submit') }}</el-button
      >
      <!-- 生成运输单 -->
      <el-button
        type="primary"
        @click="shippingOrder"
        :loading="load"
        v-if="status == 'ZT07'"
        class="fixed-bottom-btn"
        >{{ this.$t('returnDetail.btnList.shippingOrder') }}</el-button
      >
      <!-- 复制 -->
      <!--  -->
      <el-button
        type="primary"
        v-hasPermi="['2021042915373566884']"
        @click="copy('ZT06')"
        :loading="load"
        v-if="status != 'ZT01'"
        class="fixed-bottom-btn"
        >{{ this.$t('returnDetail.btnList.copy') }}</el-button
      >
      <!-- 删除 -->
      <el-button
        type="primary"
        @click="remove"
        :loading="load"
        v-show="status == 'ZT05' || status == 'ZT06'"
        class="fixed-bottom-btn"
        >{{ this.$t('returnDetail.btnList.remove') }}</el-button
      >
      <!-- 打印 -->
      <el-button
        type="primary"
        @click="print"
        :loading="load"
        v-if="status == '4' || status == '2'"
        class="fixed-bottom-btn"
        >{{ this.$t('returnDetail.btnList.print') }}</el-button
      >
      <!-- 提单 -->
      <el-button
        type="primary"
        @click="ladeOrder"
        :loading="load"
        v-if="
          this.$route.query.type == '0' &&
          status == 'ZT03' &&
          (exchangeLadingNo == '' || exchangeLadingNo == undefined)
        "
        class="fixed-bottom-btn"
        >{{ this.$t('returnDetail.btnList.ladeOrder') }}</el-button
      >
      <!-- 查看换货提单 -->
      <el-button
        type="primary"
        @click="viewLadeOrder"
        :loading="load"
        v-if="
          this.$route.query.type == '0' && exchangeLadingNo != '' && exchangeLadingNo != undefined
        "
        class="fixed-bottom-btn"
        >{{ this.$t('returnDetail.btnList.viewLadeOrder') }}</el-button
      >
      <!-- 确认 -->
      <el-button
        type="primary"
        v-if="status == 'ZT07'"
        @click="doConfirm"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('functionBtn.confirm') }}</el-button
      >
      <!-- 生成凭证 -->
      <el-button
        type="primary"
        v-hasPermi="['2021042915380187296']"
        v-if="
          status == 'ZT03' &&
          ['notgenerate', 'generated', 'postError'].indexOf(allDetail.accountingStatus) != -1
        "
        @click="handleAccountEntry"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('addInvoice.btns.accountEntry') }}</el-button
      >
      <el-button
        v-if="
          status == 'ZT03' && ['generated', 'postError'].indexOf(allDetail.accountingStatus) != -1
        "
        type="primary"
        v-hasPermi="['2021042915382778724']"
        @click="doSyncVoucherForEntityData()"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.doSyncVoucher') }}</el-button
      >
      <!-- 撤回 -->
      <el-button
        v-if="status == 'ZT07'"
        type="primary"
        @click="doReverse"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.withdraw') }}</el-button
      >
      <!-- 冲销 -->
      <el-button
        v-hasPermi="['2021042915385187058']"
        v-if="status == 'ZT03'"
        type="primary"
        @click="doReverseAccountEntry()"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('functionBtn.writeOff') }}
      </el-button>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import BaseForm from './components/baseForm'; // 基本信息
  import GoodsTable from './components/goodsTable'; // 基本信息
  // import GOODS_API from '@/api/masterData/goods';
  import SALES_API from '@/api/purchaseSalesCenter/purchaseReturn.js';
  // import COOPERATION_API from '@/api/masterData/cooperation';
  import DELIVERY_API from '@/api/logisticsCenter/transportOrder';
  import MASTER_API from '@/api/masterData/company.js';
  import API from '@/api/purchaseSalesCenter/salesReturnsAndExchange';
  import Upload from '@/components/upload';
  // import { resolve, reject } from 'q';
  import voucherMixins from '@/common/mixins/voucher.js';
  import DataBaseAPI from '@/api/dataBase';
  import XEUtils from 'xe-utils';
  export default {
    name: 'returnAdd',
    mixins: [voucherMixins],
    components: {
      BaseForm,
      GoodsTable,
      Upload,
    },
    data() {
      return {
        voucherFlag: 'AE_SO_MTL_RETURN', //凭证标识
        tableData: [],
        baseFormReturnCompanyCode: null,
        status: '',
        isDirectDeliver: '',
        currencyCode: null,
        returnOldCompanyCode: null,
        returnOldBlurCode: null,
        load: false,
        activeNames: ['1', '2', '3'],
        componentsList: ['baseForm', 'goodsTable'],
        attachments: [],
        allDetail: '',
        exchangeLadingNo: '', //附件列表
        baseData: {},
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    mounted() {
      if (this.$route.query.isEdit == true || this.$route.query.isEdit == 'true') {
        this.getDetail();
      } else if (this.$route.query.isCopy) {
        // 复制过来
        this.status = 'ZT01';
        this.allDetail = this.$route.query.allDetail;
        this.attachments = this.allDetail.attachments;
        //复制过来都能编辑
        this.allDetail.returnStatus = 'ZT01';
        this.allDetail.returnOperatorCode = this.userInfo.userCode;
        this.allDetail.returnOperatorName = this.userInfo.userName;
        this.$refs.baseForm.getDetail(this.allDetail);
        this.$refs.goodsTable.getDetail(this.allDetail);
        this.baseData = this.$refs.baseForm.baseData;
      } else {
        this.status = 'ZT01';
      }
      this.getCurrany(this.$refs.baseForm.returnCompanyCode);
    },
    methods: {
      // 确认
      doConfirmInfo(info) {
        const productData = this.$refs.goodsTable.goodsData;
        let isEmpty = false;
        productData.map((it) => {
          console.log(it.actualInboundQuantity);
          if (XEUtils.isNull(it.actualInboundQuantity)) isEmpty = true;
        });
        if (isEmpty) {
          this.$message({ showClose: true, message: '入库数量不能为空', type: 'error' });
          return;
        }
        let params = { id: this.allDetail.id, ladingNo: this.allDetail.returnNo, ...info };
        this.confirmImport(params);
      },
      confirmImport(params) {
        this.$axios.post(API.DO_CONFIRM, params).then((res) => {
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: this.$t('message.success'),
              type: 'success',
            });
            this.getDetail();
          } else if (res.data.code === 10) {
            this.$reportErrors({
              msg: res.data.msg,
              code: res.data.code,
              callback: () => {
                //确认提交，cancelValidate传值true取消校验
                params.cancelValidate = true;
                this.confirmImport(params);
              },
            });
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      insertEvent() {
        this.baseData = this.$refs.baseForm.baseData;
      },
      //清空行项目
      clearGoodsTable() {
        this.baseData = this.$refs.baseForm.baseData;
        this.$refs.goodsTable.updateStatus();
      },
      //仓库改变
      setOutboundStorageNo() {
        this.$refs.goodsTable.updateStatus();
      },
      searchModalContractNo() {
        this.getExchangeRate();
      },
      //查汇率
      getExchangeRate() {
        if (this.baseData.currencyCode == this.baseData.companyCurrencyCode) {
          this.baseData.currencyExchangeRate = 1;
          return;
        }
        const params = {
          fromCurrencyCode: this.baseData.currencyCode,
          toCurrencyCode: this.baseData.companyCurrencyCode,
        };
        if (this.baseData.currencyCode && this.baseData.companyCurrencyCode) {
          this.$axios.post(DataBaseAPI.GET_CURRENCY_EXCHANGE, params).then((res) => {
            if (res.data.code === 0) {
              if (res.data.data) {
                this.baseData.currencyExchangeRate = res.data.data.positiveRate;
              }
            } else {
              this.$alert(res.data.msg);
            }
          });
        } else {
          this.baseData.currencyExchangeRate = 1;
        }
      },
      changeCompany(val) {
        this.clearGoodsTable();
        this.getCurrany(val).then((res) => {
          console.log(res);
          // this.baseData.companyCurrencyCode=res.currencyCode;
          // this.baseData.companyCurrencyName=res.currencyName;
          // if(res &&  this.$refs.goodsTable.getTableData()){
          //   let params = {
          //      deliveryExpenseAmount:this.$refs.baseForm.baseData.deliveryExpenseAmount,
          //      returnMoneyAmount:this.$refs.baseForm.baseData.returnMoneyAmount,
          //      fromCurrencyCode:this.$refs.baseForm.baseData.currencyCode,
          //      toCurrencyCode:this.currencyCode,
          //      orderSalesReturnDetails:this.$refs.goodsTable.getTableData()
          //   }
          //   if(params.fromCurrencyCode==params.toCurrencyCode){
          //     // this.$refs.baseForm.baseData.returnCompanyCode = this.returnOldBlurCode;
          //     // this.$refs.baseForm.initDepartment();
          //     return
          //   }
          //   this.$axios.post(SALES_API.CHANGE_LEGER_CODE_NAME,params).then(item=>{
          //     if(item.data.code == 0){
          //       console.log(item.data.data)
          //       this.$refs.goodsTable.goodsData = item.data.data.orderSalesReturnDetails;
          //       this.tableData = item.data.data.orderSalesReturnDetails;
          //       this.$refs.baseForm.baseData.returnMoneyAmount = item.data.data.returnMoneyAmount;
          //       this.$refs.baseForm.baseData.deliveryExpenseAmount = item.data.data.deliveryExpenseAmount;
          //       // this.$refs.baseForm.baseData.currencyCode = this.currencyCode;
          //     }else{
          //       this.$refs.baseForm.baseData.returnCompanyCode = this.returnOldBlurCode;
          //       this.$alert(item.data.msg);
          //     }
          //   }).finally(()=>{
          //     this.$refs.baseForm.initDepartment();
          //   })
          // }else{
          //   // this.$refs.baseForm.baseData.currencyCode = this.currencyCode;
          // }
        });
      },
      throwData(val) {
        this.tableData = val;
      },
      focusChange(val) {
        this.returnOldCompanyCode = val;
      },
      changeBlur(val) {
        this.returnOldBlurCode = val;
      },
      getCurrany(val) {
        if (val) {
          return new Promise((resolve, reject) => {
            this.$axios.get(SALES_API.GET_LEGER_CODE_NAME, { companyCode: val }).then((res) => {
              if (res.data.code == 0) {
                if (res.data.data) {
                  this.baseData.companyCurrencyCode = res.data.data.currencyCode;
                  this.baseData.companyCurrencyName = res.data.data.currencyName;
                  this.currencyCode = res.data.data.currencyCode;
                  this.baseFormReturnCompanyCode = this.currencyCode;
                  this.returnOldCompanyCode = val;
                  resolve(res);
                } else {
                  this.$refs.baseForm.baseData.returnCompanyCode = this.returnOldCompanyCode;
                  this.$refs.baseForm.initDepartment();
                  this.$alert(this.$t('addInvoice.warnInfo.ledgerInfo'));
                  reject();
                }
              } else {
                reject();
              }
            });
          });
        }
      },
      // 请求详情
      getDetail() {
        this.loading.startLoading();
        const params = {
          returnType: this.$route.query.type,
          returnNo: this.$route.query.returnNo || '',
        };
        this.$axios.get(API.GET_ORDER_SALES_RETURN, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code == 0) {
            // console.log(res.data.data)
            this.status = res.data.data.returnStatus;
            this.isDirectDeliver = res.data.data.isDirectDeliver;
            this.allDetail = res.data.data;
            this.tableData = res.data.data.orderSalesReturnDetails;
            this.exchangeLadingNo = this.allDetail.exchangeLadingNo;
            this.attachments = this.allDetail.attachments;
            this.$refs.baseForm.getDetail(this.allDetail);
            this.$refs.goodsTable.getDetail(this.allDetail);
            this.baseData = this.$refs.baseForm.baseData;

            // 获取凭证ID 获取凭证列表
            this.entityDataId = res.data.data.id;
            this.getAccountEntry();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 计算总金额
      calculate(returnMoneyAmount) {
        this.$refs.baseForm.getReturnMoneyAmount(returnMoneyAmount);
      },
      calculateQuantity(totalReturnQuantity) {
        this.$refs.baseForm.getTotalReturnQuantity(totalReturnQuantity);
      },
      calculateFee(deliveryExpenseAmount) {
        this.$refs.baseForm.getDeliveryExpenseAmount(deliveryExpenseAmount);
      },
      calculateNonInvoiceQuantity(nonInvoiceQuantity) {
        this.$refs.baseForm.getNonInvoiceQuantity(nonInvoiceQuantity);
      },
      calculateInvoiceAmount(invoiceAmount) {
        this.$refs.baseForm.getInvoiceAmount(invoiceAmount);
      },
      save(btnType) {
        let params = {};
        if (btnType == 'ZT02') {
          let momentObj = this.$refs['baseForm'].exportChildData(btnType);
          if (momentObj) {
            params = Object.assign(params, momentObj);
            Promise.resolve(this.$refs.goodsTable.exportChildData(btnType)).then((res) => {
              if (res) {
                params = Object.assign(params, res);
                this.saveData(btnType, params);
              }
            });
          } else {
            return;
          }
        } else {
          this.componentsList.some((item) => {
            let momentObj = this.$refs[item].exportChildData(btnType);
            params = Object.assign(params, momentObj);
          });
          this.saveData(btnType, params);
        }
      },
      saveData(btnType, params) {
        params = Object.assign(params, {
          tenantCode: this.userInfo.tenantCode,
          companyCode: this.userInfo.companyCode,
          departmentCode: this.userInfo.departmentCode,
          companyName: this.userInfo.companyName,
          departmentName: this.userInfo.departmentName,
          returnType: this.$route.query.type,
          returnStatus: 'ZT06',
          gmtCreate: '',
          attachments: this.attachments,
          version: this.$route.query.isEdit ? this.allDetail.version : '',
        });
        let flag = true;
        params.orderSalesReturnDetails.length &&
          params.orderSalesReturnDetails.map((item) => {
            if (item.availableReturnQuantity <= 0) {
              this.$message({
                showClose: true,
                message: this.$t('returnDetail.msg.quantityTip'),
                type: 'error',
              });
              flag = false;
            }
          });
        if (!flag) {
          return;
        }
        this.loading.startLoading();
        // 保存提交

        let url = btnType == 'ZT02' ? API.SUBMIT_ORDER_SALES_RETURN : API.SAVE_ORDER_SALES_RETURN;
        this.$axios.post(url, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 10) {
            this.$reportErrors({
              msg: res.data.msg,
              code: res.data.code,
              callback: () => {
                //确认提交，cancelValidate传值true取消校验
                params.cancelValidate = true;
                this.saveData(btnType, params);
              },
            });
          } else if (res.data.code == 0) {
            if (btnType == 'ZT02') {
              this.$message({
                showClose: true,
                message: this.$route.query.isEdit
                  ? this.$t('returnDetail.msg.updateSusscess')
                  : this.$t('returnDetail.msg.submitSusscess'),
                type: 'success',
              });
            } else {
              this.$message({
                showClose: true,
                message: this.$route.query.isEdit
                  ? this.$t('returnDetail.msg.updateSusscess')
                  : this.$t('returnDetail.msg.saveSussess'),
                type: 'success',
              });
            }
            if (btnType == 'ZT06') {
              if (this.$route.name == 'returnAdd') {
                this.dblclickEvent(res.data.data);
              } else {
                this.getDetail();
                this.getCurrany(this.$refs.baseForm.returnCompanyCode);
              }
            } else {
              let pathList = {
                fromPath: {
                  path: '/salesReturnAndExchange/returnAdd',
                  name: 'returnAdd',
                  meta: {
                    keepAlive: true,
                    title: this.$t('returnDetail.path.addPathName'),
                  },
                },
                toPath: {
                  path: '/salesReturnAndExchange/overviewList',
                  name: 'overviewList',
                  meta: {
                    keepAlive: false,
                    title: this.$t('returnDetail.path.listPathName'),
                  },
                },
              };
              this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
                this.$nextTick(() => {
                  this.$router.push(pathList.toPath);
                });
              });
            }
          } else {
            if (!res.data.data) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            } else {
              if (this.$route.name == 'returnAdd') {
                this.dblclickEvent(res.data.data);
              } else {
                this.getDetail();
                this.getCurrany(this.$refs.baseForm.returnCompanyCode);
              }
            }
          }
        });
      },
      //保存--修改
      dblclickEvent(value) {
        let name = this.$route.name;
        let path = {
          fromPath: {
            path: `/salesReturnAndExchange/${name}`,
            name: name,
            meta: {
              keepAlive: true,
              title:
                name == 'returnAdd'
                  ? this.$t('salePurchase.message.addSalesReturns')
                  : this.$t('salePurchase.message.salesReplacementAdd'),
            },
          },
          toPath: {
            path: '/salesReturnAndExchange/returnEdit',
            name: 'returnEdit',
            meta: {
              keepAlive: true,
              title: this.$t('salePurchase.message.editSalesReturns'),
            },
            query: {
              type: '1', //退货
              isEdit: true,
              returnNo: value.returnNo,
            },
          },
        };
        if (value.returnType != 1) {
          (path.toPath.path = '/salesReturnAndExchange/changeEdit'),
            (path.toPath.name = 'changeEdit'),
            (path.toPath.meta.title = this.$t('salePurchase.message.salesReplacementEditor'));
          path.toPath.query.type = '0'; //换货
        }
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //更新附件列表
      uploadList(value) {
        this.attachments = [];
        if (value.length) {
          value.map((item, index) => {
            this.attachments.push({
              ...item,
              sortNo: index,
            });
          });
        }
      },
      // 接口加法计算
      calculateAdd(adds) {
        return new Promise((resolve, reject) => {
          this.$axios.post(API.GET_ADD_AMOUNT, { adds }).then((res) => {
            if (0 == res.data.code) {
              resolve(res.data.data);
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
              reject();
            }
          });
        });
      },
      // 计算总金额
      calAmount() {
        return new Promise((resolve, reject) => {
          this.$axios.post(API.GET_RETURN_MONEY_AMOUNT, {}).then((res) => {
            if (0 == res.data.code) {
              resolve(res.data.data.returnMoneyAmount);
            } else {
              reject();
            }
          });
        });
      },
      copy() {
        let detailData;
        const params = {
          returnType: this.$route.query.type,
          returnNo: this.$route.query.returnNo,
        };
        // 获取详情信息
        this.$axios.get(API.GET_ORDER_SALES_RETURN, params).then((res) => {
          if (res.data.code == 0) {
            detailData = res.data.data;
            // 判断当前所有的退货数量是否大于变化后的可退货数量
            let orderSalesReturns = [];
            detailData.orderSalesReturnDetails &&
              detailData.orderSalesReturnDetails.map((item) => {
                orderSalesReturns.push({
                  availableReturnQuantity: item.ladingQuantity,
                  ladingNo: item.ladingNo,
                  ladingDetailNo: item.ladingDetailNo,
                  businessInboundBatchNo: item.businessInboundBatchNo,
                });
              });
            this.$axios.post(API.GET_LADING_NO_SUM, { orderSalesReturns }).then((res) => {
              if (res.data.code == 0) {
                res.data.data.length &&
                  res.data.data.map((item, index) => {
                    detailData.orderSalesReturnDetails[index].availableReturnQuantity =
                      item.returnQuantity;
                    detailData.orderSalesReturnDetails[index].returnQuantity = '0';
                    detailData.orderSalesReturnDetails[index].returnMoneyAmount = '0';
                  });
                // 计算总金额、总数量
                let addsMount = [];
                let addsNum = [];
                detailData.orderSalesReturnDetails.map((item) => {
                  addsMount.push(item.returnMoneyAmount);
                  addsNum.push(item.returnQuantity);
                });
                Promise.all([this.calculateAdd(addsMount), this.calculateAdd(addsNum)]).then(
                  (res) => {
                    if (res) {
                      detailData.returnMoneyAmount = res[0];
                      detailData.totalExchangeQuantity = res[1];
                      this.goNewPage(detailData);
                    }
                  }
                );
              }
            });
          }
        });
      },
      goNewPage(allDetail) {
        allDetail.returnNo = '';
        let pathList = {
          path:
            this.$route.query.type == '1'
              ? '/salesReturnAndExchange/returnAdd'
              : '/salesReturnAndExchange/changeAdd',
          name: this.$route.query.type == '1' ? 'returnAdd' : 'changeAdd',
          meta: {
            keepAlive: false,
            title: this.$t('returnDetail.path.addPathName'),
          },
          query: {
            type: this.$route.query.type,
            isCopy: true,
            isEdit: false,
            allDetail,
          },
        };
        this.$store.dispatch('tagsView/addTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList);
          });
        });
      },
      delete() {
        const params = {
          returnNo: this.$route.query.returnNo,
          returnType: this.$route.query.type,
          version: this.allDetail.version,
        };
        this.loading.startLoading();
        // 保存提交
        this.$axios.post(API.DELETE_ORDER_SALES_RETURN, params).then((res) => {
          if (res.data.code == 0) {
            this.loading.endLoading();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('returnDetail.msg.removeSussess'),
            });
            let pathList = {
              fromPath: {
                path: '/salesReturnAndExchange/returnAdd',
                name: 'returnAdd',
                meta: {
                  keepAlive: true,
                  title: this.$t('returnDetail.path.addPathName'),
                },
              },
              toPath: {
                path: '/salesReturnAndExchange/overviewList',
                name: 'overviewList',
                meta: {
                  keepAlive: false,
                  title: this.$t('returnDetail.path.listPathName'),
                },
              },
            };
            this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
              this.$nextTick(() => {
                this.$router.push(pathList.toPath);
              });
            });
          }
        });
      },
      remove() {
        this.$confirmAction()
          .then(() => {
            this.delete();
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('personnel.table.deletFalse'),
            });
          });
      },
      doReverse() {
        this.$confirmAction('撤回？', '是否确认撤回？')
          .then(() => {
            let params = {
              id: this.allDetail.id,
            };
            this.$axios.post(API.DO_REVOKE, params).then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'success',
                });
                this.getDetail();
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$('personnel.table.revokeFalse'),
            });
          });
      },
      // 生成运输单
      shippingOrder() {
        const query = {
          otherNo: this.allDetail.returnNo,
          pageNum: 1,
          pageSize: 10,
        };
        this.$axios.post(DELIVERY_API.LIST_DELIVERY_PAGE, query).then((res) => {
          if (0 == res.data.code) {
            if (res.data.data.list.length <= 0) {
              this.makeTransport();
            } else {
              this.$message({
                showClose: true,
                message: this.$t('returnDetail.msg.transTip'),
                type: 'error',
              });
            }
          }
        });
      },
      makeTransport() {
        let params = {
          tenantCode: this.userInfo.tenantCode,
          companyCode: this.userInfo.companyCode,
          departmentCode: this.userInfo.departmentCode,
          companyName: this.userInfo.companyName,
          departmentName: this.userInfo.departmentName,
          deliveryStatus: '1',
          salesmanNo: this.allDetail.returnSalesmanCode,
          salesmanName: this.allDetail.returnSalesmanName,
          deliveryDepartment: this.allDetail.departmentName,
          otherNo: this.allDetail.returnNo,
          deliveryType: '4', //运输类型为其他
          pickupStorageAddress: this.allDetail.deliveryAddress,
          shiptoStorageName: this.allDetail.inboundStorageName,
          shiptoStorageAddress: '',
          deliveryQuantity: this.allDetail.totalExchangeQuantity,
          deliveryMethod: this.allDetail.deliveryMethod,
          otherExpenseType: this.allDetail.inboundExpenseTaker == 'CD01' ? 'QTFY02' : '',
          otherExpense:
            this.allDetail.inboundExpenseTaker == 'CD01' ? this.allDetail.inboundExpenseAmount : '',
          shiptoMark: this.allDetail.mark,
        };
        let deliveryDetailStr = [];
        const query = {
          returnType: this.allDetail.returnType,
          returnNo: this.allDetail.returnNo,
        };
        this.$axios.get(API.GET_ORDER_SALES_RETURN, query).then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.orderSalesReturnDetails.length) {
              res.data.data.orderSalesReturnDetails.map((item) => {
                let itemData = {
                  otherNo: item.returnDetailNo,
                  productName: item.productDesc,
                  deliveryQuantity: item.returnQuantity,
                  contractUnit: item.unit,
                };
                deliveryDetailStr.push(JSON.stringify(itemData));
              });
              params.deliveryDetailStr = '[' + deliveryDetailStr.join(',') + ']';
            } else {
              params.deliveryDetailStr = '[]';
            }
            if (this.allDetail.inboundStorageNo) {
              Promise.resolve(this.searchWarehouse(this.allDetail.inboundStorageNo)).then((res) => {
                params.shiptoStorageAddress = res[0].storageAddress;
                this.makeData(params);
              });
            } else {
              this.makeData(params);
            }
          }
        });
      },
      makeData(params) {
        this.loading.startLoading();
        this.$axios.post(DELIVERY_API.SAVE_DELIVERY, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              message: this.$t('returnDetail.msg.transSuccess'),
              type: 'success',
            });
            let pathList = {
              path: '/salesReturnAndExchange/overviewList',
              name: 'overviewList',
              meta: {
                keepAlive: false,
                title: this.$t('returnDetail.path.listPathName'),
              },
            };
            this.$store.dispatch('tagsView/addTabView', pathList).then(() => {
              this.$nextTick(() => {
                this.$router.push(pathList);
              });
            });
          } else {
            this.$message({
              showClose: true,
              message: this.$t('returnDetail.msg.transFailed'),
              type: 'error',
            });
          }
        });
      },
      searchWarehouse(storageCode) {
        return new Promise((resolve, reject) => {
          const query = {
            storageCode,
            adminFlag: this.userInfo.adminFlag,
            //已生效的仓库
            currentStatus: 'ZT03',
          };
          this.$axios.post(MASTER_API.GET_STORAGE_LIST, query).then((res) => {
            if (0 == res.data.code) {
              resolve(res.data.data);
            } else {
              reject();
            }
          });
        });
      },
      // 提单
      ladeOrder() {
        let changeDetail = {
          ladingType: '2',
          returnNo: this.allDetail.returnNo,
          storageNo: this.allDetail.outboundStorageNo,
          storageName: this.allDetail.outboundStorageName,
          businessLadingTotalAmount: this.allDetail.returnMoneyAmount,
          ladingTotalQuantity: this.allDetail.totalExchangeQuantity,
          deliveryAddress: this.allDetail.exchangeAddress,
          deliveryDate: this.allDetail.predictExchangeAddress,
          ladingSalesmanNo: this.allDetail.returnSalesmanCode,
          ladingSalesmanName: this.allDetail.returnSalesmanName,
          ladingCurrency: 'CNY',
          customerNo: this.allDetail.purchaseUnitNo,
          customerName: this.allDetail.purchaseUnitName,
          shippingMethod: this.allDetail.deliveryMethod,
          ladingBusinessDepartmentNo: this.allDetail.returnDepartmentCode,
          ladingBusinessDepartmentName: this.allDetail.returnDepartmentName,
          storageLadingPicking: [],
          returnStatus: this.allDetail.returnStatus,
        };
        // 交货方式和换货方式对应
        if (this.allDetail.changeMethod == 'HHFS01') {
          changeDetail.deliveryMethod = 'JHFS02';
        } else if (this.allDetail.changeMethod == 'HHFS02') {
          changeDetail.deliveryMethod = 'JHFS01';
        } else if (this.allDetail.changeMethod == 'HHFS03') {
          changeDetail.deliveryMethod = 'JHFS04';
        }
        if (this.allDetail.returnStatus == 'ZT02') {
          changeDetail.returnStatusName = this.$t('salePurchase.message.examinationApproval');
        } else if (this.allDetail.returnStatus == 'ZT03') {
          changeDetail.returnStatusName = this.$t('salePurchase.message.approve');
        } else if (this.allDetail.returnStatus == 'ZT04') {
          changeDetail.returnStatusName = this.$t('salePurchase.message.beenDisabled');
        } else if (this.allDetail.returnStatus == 'ZT05') {
          changeDetail.returnStatusName = this.$t('salePurchase.message.approvalDismiss');
        } else if (this.allDetail.returnStatus == 'ZT06') {
          changeDetail.returnStatusName = this.$t('salePurchase.message.theSaved');
        } else if (this.allDetail.returnStatus == 'ZT07') {
          changeDetail.returnStatusName = this.$t('salePurchase.message.openBill');
        }
        if (this.allDetail.orderSalesReturnDetails.length) {
          this.allDetail.orderSalesReturnDetails.map((item) => {
            let itemData = {
              ladingDetailNo: item.returnDetailNo,
              productNo: item.productNo,
              productDesc: item.productDesc,
              ladingUnit: item.unit,
              ladingQuantity: item.returnQuantity,
              availableQuantity: item.returnQuantity,
              businessChangingUnitPrice: item.returnUnitPrice,
              businessContractUnitPrice: item.returnUnitPrice,
              businessLadingAmount: item.returnMoneyAmount,
            };
            changeDetail.storageLadingPicking.push(itemData);
          });
        }
        //跳转到销售提单页面
        let pathList = {
          fromPath: {
            path: '/salesReturnAndExchange/changeEdit',
            name: 'changeEdit',
            meta: {
              keepAlive: true,
              title: this.$t('salePurchase.message.salesReplacementEditor'),
            },
          },
          toPath: {
            path: '/salePurchase/salesLadingbillAdd',
            name: 'salesLadingbillAdd',
            meta: {
              keepAlive: false,
              title: this.$t('salePurchase.message.salesBillLadingCreation'),
            },
            query: {
              changeDetail: JSON.stringify(changeDetail),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
      viewLadeOrder() {
        //跳转到销售提单页面
        let pathList = {
          fromPath: {
            path: '/salesReturnAndExchange/changeEdit',
            name: 'changeEdit',
            meta: {
              keepAlive: true,
              title: this.$t('salePurchase.message.salesReplacementEditor'),
            },
          },
          toPath: {
            path: '/salePurchase/salesLadingbillEdit',
            name: 'salesLadingbillEdit',
            meta: {
              keepAlive: false,
              title: this.$t('salePurchase.message.salesBillLadingCreation'),
            },
            query: {
              ladingNo: this.exchangeLadingNo,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
      // 直拨的实发在审核通过后可编辑实际入库数量
      saveActualInboundQuantity() {
        let params = {
          returnNo: this.$route.query.returnNo,
          feedbackType: '01',
          orderSalesReturnDetails: this.$refs.goodsTable.exportChildData().orderSalesReturnDetails,
        };
        this.$axios.post(API.UPDATE_ACTUAL_QUANTITY, params).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              message: this.$t('returnDetail.msg.makeSuccess'),
              type: 'success',
            });
            this.getDetail();
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
    },
  };
</script>
